import { Outlet, useNavigate } from 'react-router';
import { Dialog } from '@mui/material';

import { PopupTransition } from '~/components/Transitions';

export const ModalOutlet = () => {
    const navigate = useNavigate();

    return (
        <Dialog
            fullWidth
            maxWidth={'sm'}
            open={true}
            slots={{ transition: PopupTransition }}
            onClose={(_, reason) => {
                if (reason !== 'backdropClick') {
                    navigate(-1);
                }
            }}
            sx={{ '& .MuiDialog-paper': { p: 0 }, transition: 'transform 225ms' }}
        >
            <Outlet />
        </Dialog>
    );
};
